/**
 * Stat tile. Screen spec 4.10, the overview's quick links.
 *
 * A label, one fact, a chevron. NEVER MORE THAN ONE FACT, and the component
 * cannot take a second: a tile that says "6 tables, 118 MB, changed 2 hours
 * ago" is a dashboard cell, and this product does not have a dashboard. It has
 * a question ("is my app fine") that the band above already answered, and four
 * doors underneath it.
 *
 * The fact is mono, right aligned, in its own column, so four tiles stacked
 * make a truth column a person reads down in one movement. That column is the
 * reason these are rows rather than cards: cards would put each fact in a
 * different place on the screen and turn one glance into four.
 */

import { Link } from 'react-router';
import '../../styles/components/stat-tile.css';

export interface StatTileProps {
  label: string;
  /** One fact. Already formatted, already translated. */
  fact: string;
  to: string;
  /**
   * A fact that is not a machine value ("No errors") drops the mono face:
   * mono is for a literal out of the machine, never for a sentence about one.
   */
  plain?: boolean;
}

export function StatTile({ label, fact, to, plain = false }: StatTileProps) {
  return (
    <Link className="stat" to={to}>
      <span className="stat__label">{label}</span>
      <span className={plain ? 'stat__fact' : 'stat__fact mono'}>{fact}</span>
      <span className="stat__chev" aria-hidden="true">
        <svg viewBox="0 0 16 16" width="12" height="12" focusable="false">
          <path
            d="M6 3.5 10.5 8 6 12.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </Link>
  );
}
